import React from 'react'
import { createContext, useState, useCallback } from "react";
import AuthContext from "./AuthContext.js";
import ClientContext from "./ClientContext.js";
import StatusContext from './StatusContext.js';
import axios from "axios"

import { config } from '../config.js';
import { sortChats } from './StatusContext.js';

const DocumentAnalysisContext = createContext();

export default DocumentAnalysisContext;

var topic = '';
  
export const DocumentAnalysisProvider = ((props) => {
    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);

    const[chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [confirmDelete, setConfirmDelete] = useState([])
    const [showProgressDialog, setShowProgressDialog] = useState(false)

 
    const [status, setStatus] = useState();

    const[attachedFiles, setAttachedFiles] = useState([])

    const[textvectorization, setTextVectorization] = useState(true)
   
    const {
        currentUser, 
        checkCurrentUser,
        checkServerCode, 
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        temperature,
        ScrollResponse,
        setIsLoading,
        isLoading,
        changeLanguage,
        getChats,
        setShowLoginDialog,
        handleFocus,
        setWaitOnResponse,
        getAIProvider, 
        getChatGPTModel,
        getAIName,
        
        
    } = React.useContext(StatusContext);

   
    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);

    const isPromptandResponses = () => {
        return promptsandresponses.length;
    }

    const onClearChat = () => {
        setPromptsAndResponses([])
        setConfirmDelete([])
        setChatName('')
        setStatus('')
        setChatPrompt('')

   
        topic='';
    }   

    const deleteChat = async (deletionChat) => {

        console.log("Delete story:", deletionChat)

        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        let newchatNames = [];

        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/documentanalysis/get", {currentUser}) 
            newchatNames =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        let filteredChats = newchatNames.filter(chat => chat.id !== deletionChat.id)
        let adjustedChats = sortChats(filteredChats)
        console.log("Adjusted Chats:", adjustedChats)
              
        var templates = JSON.stringify( adjustedChats)
       
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/documentanalysis/save", {currentUser, templates},{
                withCredentials:true
            })
        }
        catch (err) {
            setIsLoading(false)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return;
        }

        setChatNames(adjustedChats);
        
       
        setIsLoading(false)    
    }

    const displayChat = (displayedChat) => {

        console.log("Story:", displayedChat)
        onClearChat();

        setTimeout(() => {
          
        //onClearChat();

        //fix prompts ids to match array indexes
        let index = 0;
        displayedChat.promptsandresponses.forEach((item) => {
                item.id = index;
                index++   
        })   
       
        setPromptsAndResponses(displayedChat.promptsandresponses)
      
        setChatName(displayedChat.chatname)

        var deletes = []
        displayedChat.promptsandresponses.forEach((item) => {
             let a = {
                id: item.id,
                state: false
             }
             deletes.push(a)   
        })

        setConfirmDelete(deletes)
    },0)
    }

    const onDeletePrompt = (deletionChat) => {
        if (isLoading)
            return;
        let index = promptsandresponses.indexOf(deletionChat)
        let filteredChats = promptsandresponses.filter(chat => chat.id !== deletionChat.id)
        setPromptsAndResponses(filteredChats)
        
        let deleteconfirm = [...confirmDelete]
        deleteconfirm.splice(index, 1)
        setConfirmDelete(deleteconfirm)

    }

    const changeConfirmDelete = (prompt, flag) => {
        let a = [...confirmDelete]
        a.forEach((item)=>{
            if (item.id === prompt.id)
                item.state = flag
        })

        setConfirmDelete(a)

    }

    const onSave = async () => {
        console.log("OnSave DocumentAnalysis:")

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }

        let exists = false;
    
        let newChats = [];
        let newChat=[];
        let newchatNames = [];


        setIsLoading(true);

        let chatstatus = await getChats('documentanalysis');
       
        if (chatstatus.status !== 200)
        {
            setStatusNavbar("Unable to retrieve topics data.")
            setIsLoading(false);
            return;
        }

        newchatNames = chatstatus.chats;

        if ( chatstatus.status === 200)
        {
            newchatNames.forEach((chat) => {
                if (chat.chatname === chatName) {
                    let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }

                    chat.promptsandresponses = promptsandresponses;
                    newChat = chat;
                    exists = true;
                }
                newChats.push(JSON.parse(JSON.stringify(chat)));
            })
        }

        if (!exists) {
            let i = 0;

            newchatNames === 0 ? i = 1 : i = newchatNames.length;
       
            newChat = {
                id: i,
                chatname: chatName,
                topic: topic,
                promptsandresponses: promptsandresponses,
            };

            newChats.push(newChat);
            let adjustedChats = sortChats(newChats)
            newChats = [...adjustedChats]
        }
            
        let templates = JSON.stringify( newChats)

        console.log("Templates size:", templates.length)
       
        
        try{
           await axios.post(config.url.API_URL + "/deda_ai_api/documentanalysis/save", {currentUser, templates},{
                withCredentials:true
            })
        }
        catch (err) {
            setIsLoading(false);
            //setStatus(`Error: ${checkServerCode(err.code)}`)
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
            return;
        }
       
        setChatNames(newChats)
        setIsLoading(false);
        
    }

    const onSubmitChat = () => {
        
        if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }

        SendRequest(chatPrompt)
        
    }

    const onResubmitChat = (prompt) => {
    
        SendRequest(prompt.prompt)
        
    }

    async function SendRequest(request) {
        
        setStatus("");
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        if (request.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }

         if (attachedFiles.length === 0)
        {
            alert(changeLanguage('documentanalysis', 'filenotattached'))
            return
        }

        let i = 0;
        if (promptsandresponses.length)
        {
            i = promptsandresponses[promptsandresponses.length-1].id + 1
        }

        let r = {
            id:i,
            prompt:request,
            response:"",
            aiprovider: getAIProvider(),
            aimodel: getChatGPTModel(),
            ainame: getAIName(),
        }
       
        setPromptsAndResponses([...promptsandresponses, r]) 
        ScrollResponse()
       
       
        if (promptsandresponses.length > 0)
        {
            setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
            handleFocus()
        }
      

        if (confirmDelete.length <= promptsandresponses.length)
        {
            let a = {
                id: i,
                state: false
            }
            setConfirmDelete([...confirmDelete, a ]) 
        }

        setIsLoading(true)

        let rqst='';
        rqst += request

        setChatPrompt('')
        
        let req = {
            user: currentUser,
            request: rqst,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getChatGPTModel(),
            ainame: getAIName(),
        }

       
            try {
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/documentanalysis/requestmultiuser", {req},{
                        withCredentials:true
                    })

                let server_response =res.data;
             
                if (promptsandresponses.length)
                {
                    i = promptsandresponses[promptsandresponses.length-1].id + 1
                } else 
                {
                    i = 0
                }
            
                r = {
                    id: i,
                    prompt: request,
                    response: server_response.data,
                    aiprovider: getAIProvider(),
                    aimodel: getChatGPTModel(),
                    ainame: getAIName(),
                };

                //console.log("Response:", server_response.data)

                setPromptsAndResponses([...promptsandresponses, r])
              
            
                setWaitOnResponse('')
                handleFocus()
                
                updateCredits(server_response.tokens)
               
            } catch(err)
            {
                console.log("Error:", err)
                setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
                setStatus(`Error: ${checkServerCode(err.response.data)}`)
            
            }

        setIsLoading(false)
    }

    function formatFileSize(bytes) {
    if (bytes < 1024 * 1024) {
        // Less than 1MB - show in KB, rounded up
        const kb = Math.ceil(bytes / 1024);
        return kb + ' KB';
    } else {
        // 1MB or more - show in MB with 1 decimal place
        const mb = (bytes / (1024 * 1024)).toFixed(1);
        return mb + ' MB';
    }
}


     const addFile = async (file_name, file_type, file_size, formData) => {

        console.log("Add file")
        
        setStatus('')
        setIsLoading(true)
        setShowProgressDialog(true)

        try {

            
            let res = await axios.post(
                    config.url.API_URL + "/deda_ai_api/documentanalysis/addfiletextvectorization", 
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            withCredentials: true
                        }
                );
            
            //Prepare text representation of file size
            let fileSizeText = formatFileSize(file_size)

            //get current date
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(currentDate.getDate()).padStart(2, '0');

            //const formattedDate = `${year}-${month}-${day}`;
            //console.log(formattedDate); // e.g., "2024-04-15"
       
            const addedFile =  { 
                    name: file_name, 
                    type: file_type, 
                    content: '', 
                    size: file_size, 
                    sizeText: fileSizeText,
                    added_year: year,
                    added_month: month,
                    added_date: day
                }

            updateCredits(res.data.tokens)
        
            let file_details = JSON.stringify(addedFile)

            try {
                await axios.post(config.url.API_URL + "/deda_ai_api/documentanalysis/savefiledetails", { currentUser, file_name, file_details }, {
                    withCredentials: true
                })
            }
            catch (err) {
                setIsLoading(false);
                setStatus(`Error: ${checkServerCode(err.code)}`)
                return
            }

            let a = [...attachedFiles]
            a.push(addedFile)
            setAttachedFiles([...a])
        
            
        }
        catch (err){
            if (err.response)
            {
                setStatus(err.response.data.message)
            }
            else
            {
                setStatus(`Error: ${checkServerCode(err.code)}`)
            }

        }
        
        setIsLoading(false)
        setShowProgressDialog(false)

    }

     const removeFile = async (file_id) => {
       
        setStatus('')
        setIsLoading(true)

        //remove file from attachedFiles array
        const updatedFiles = [...attachedFiles]
        updatedFiles.splice(file_id, 1);
     
        let req = {
            user: currentUser,
            file_id: file_id,
            file_name : attachedFiles[file_id].name,
        }
        
        try {
            
            await axios.post(config.url.API_URL + "/deda_ai_api/documentanalysis/removefilemultiuser", {req},{
                    withCredentials:true
                })
            

            //Save file details in EmbeddedFiles table

            let filename = attachedFiles[file_id].name

            try {
                await axios.post(config.url.API_URL + "/deda_ai_api/documentanalysis/removefiledetails", { currentUser, filename }, {
                    withCredentials: true
                })
            }
            catch (err) {
                setIsLoading(false);
                setStatus(`Error: ${checkServerCode(err.code)}`)
                return
            }

            setAttachedFiles([...updatedFiles])
            
        }
        catch (err){
            setStatus(`Error: ${checkServerCode(err.code)}`)

        }
        
        setIsLoading(false)
        
    }

    const getFileDetails = useCallback (async () => {
  
        try{
            let q = "/deda_ai_api/documentanalysis/getfiledetails"
            const res = await axios.post(config.url.API_URL + q, {currentUser}) 
          
            if (res.data.length > 0) {
                let files = []
                for (let i = 0; i < res.data.length; ++i)
                {
                    let a = JSON.parse(res.data[i].filename) 
                    files.push(a)
                }

                setAttachedFiles(files)

            }
            else{
                // Handle case when res.data is empty
                console.log("No data in res.data")
            }
        } 
        catch(err)
            {
                setIsLoading(false);
                console.log("getFileDetails-error:", err.response.data)
                
                //setStatus(`Error: ${checkServerCode(err.response.data)}`)
            }
        }, [currentUser, setIsLoading]
    
    )

    return <DocumentAnalysisContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse, 
        promptsandresponses, 
        chatName,
        chatNames,
        setChatName,
        setChatNames,
        onSubmitChat,
        onClearChat,
  
        onSave,
        deleteChat,
        displayChat,
        onDeletePrompt, 
        changeConfirmDelete,
        confirmDelete,
        isPromptandResponses,
     
        status,
        setStatus,
       
        topic,
    
        onResubmitChat,

        addFile,
        removeFile,

        showProgressDialog,

        getFileDetails,
        attachedFiles,

        textvectorization,
        setTextVectorization,
       
    }}>
        {props.children}
    </DocumentAnalysisContext.Provider>
})

